// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownFilterTrending_dropdown__I2hI+","padded":"DropdownFilterTrending_padded__60FBN","inputContainer":"DropdownFilterTrending_inputContainer__M2y9E"};